import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HelpIcon, RawButton, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

const Button = styled(Box)`
  &:hover > span {
    color: ${({ theme }) => theme.colors.buttonPrimary};
  }

  &:hover > svg {
    fill: ${({ theme }) => theme.colors.buttonPrimary};
  }
`;

interface Props {
  onClick: () => void;
  isAccent?: boolean;
}

const GuidelinesButton: React.FC<Props> = ({ onClick, isAccent = false }) => {
  const { t } = useTranslation();

  return (
    <RawButton data-testId="guidelines-button" onClick={onClick}>
      <Button direction="row" align="center">
        <Text
          weight={400}
          color={isAccent ? 'textAccent' : 'textSecondary'}
          margin={{ right: 'spacing2' }}
        >
          {t('Guidelines')}
        </Text>
        <HelpIcon size="16px" color={isAccent ? 'iconAccent' : 'iconSecondary'} />
      </Button>
    </RawButton>
  );
};

export default GuidelinesButton;
